module.exports = __webpack_public_path__ + "media/steps/car_bcg_2-lights-on-98c1b88e.png";